<template>
    <section>
        <loading :active.sync="isLoading"
            :can-cancel="true"
            color="#5bad2b"
            :is-full-page="fullPage"></loading>
        <div class="row"  style="background-color: #303439;">
            <div class="headerClass">
                <div class="col-md-6">
                    <carousel :per-page="1" class="c-slide" :autoplay="true" :autoplayHoverPause="true" :loop="true">
                    <slide>
                        <div class="row">
                        <div class="col-md-9">
                            <br>
                            <h3 class="mt-2 c-slide-title">Hello {{userInfo.organization}} !</h3>
                            <p class="mt-2 c-slide-font">Screenit just don’t promote our application, we work with our partners and progress together.</p>
                        </div>
                        <div class="col-md-3">
                            <img src="../assets/img/dashboard_welcome.gif" class="pull-right" style="width: 150px;">
                        </div>
                        </div>
                    </slide>
                    <slide>
                        <div class="row">
                        <div class="col-md-9">
                            <br>
                            <h3 class="mt-2 c-slide-title">Hello {{userInfo.organization}} !</h3>
                            <p class="mt-2 c-slide-font">
                            Interview session has been recorded and available in the result module for the future references.</p>
                        </div>
                        <div class="col-md-3">
                            <img src="../assets/img/gif2.gif" class="pull-right" style="width: 150px;">
                        </div>
                        </div>
                    </slide>
                    <slide>
                        <div class="row">
                        <div class="col-md-9">
                            <br>
                            <h3 class="mt-2 c-slide-title">Hello {{userInfo.organization}} !</h3>
                            <p class="mt-2 c-slide-font">
                                Scheduled Interviews can be rescheduled for unanticipated situation.
                            </p>
                        </div>
                        <div class="col-md-3">
                            <img src="../assets/img/gif3.gif" class="pull-right" style="width: 150px;">
                        </div>
                        </div>
                    </slide>
                    </carousel>
                </div>
                <div class="col-md-5" v-if="upcoming_count > 0">
                    <div class="row upcoming upcomingData">
                        <div class="col-md-7">
                            <div class="box">
                                <div class="box-header">
                                <h5 class="box-title"><b>Upcoming Interview</b></h5>
                                </div>
                                <div class="box-body" style="height: auto;">
                                    <ul class="products-list product-list-in-box mt-2">
                                    <li>
                                        <div class="product-img">
                                            <img @click="showModal(upcoming_Schedule.user_id, upcoming_Schedule.post_id)" v-if="upcoming_Schedule.profile_picture !='' && upcoming_Schedule.profile_picture !=null" :src="`${upcoming_Schedule.profile_picture}`">
                                            <img @click="showModal(upcoming_Schedule.user_id, upcoming_Schedule.post_id)" v-if="(upcoming_Schedule.profile_picture =='' || upcoming_Schedule.profile_picture == null) && upcoming_Schedule.gender == null" src="../assets/img/default.png">
                                            <img @click="showModal(upcoming_Schedule.user_id, upcoming_Schedule.post_id)" v-if="(upcoming_Schedule.profile_picture =='' || upcoming_Schedule.profile_picture ==null) && upcoming_Schedule.gender == 'Female'" src="../assets/img/female_default.png">
                                            <img @click="showModal(upcoming_Schedule.user_id, upcoming_Schedule.post_id)" v-if="(upcoming_Schedule.profile_picture =='' || upcoming_Schedule.profile_picture ==null) && upcoming_Schedule.gender == 'Male'" src="../assets/img/male_default.png">
                                        </div>
                                        <div class="product-info d1">
                                            <a href="javascript:void(0)" @click="showModal(upcoming_Schedule.user_id, upcoming_Schedule.post_id)" class="product-title c-bl">{{upcoming_Schedule.first_name}} {{upcoming_Schedule.last_name}}
                                            </a>
                                            <span class="product-description">
                                                <span class="text-muted">Position</span>
                                                <span class="product-title c-b1"> {{upcoming_Schedule.job_tittle}}</span>
                                            </span>
                                        </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="box">
                            <div class="box-header">
                                <span class="pull-right arrow-next"><i class="uil uil-arrow-right"></i></span>
                                <span class="pull-right arrow-next mr-2"><i class="uil uil-arrow-left"></i></span>
                            </div>
                            <div class="box-body" style="height: auto;">
                                <img src="../assets/img/upcoming-schedule.svg" style="width: 84px;">
                            </div>
                            </div>
                        </div>
                        <div class="col-md-12 upcoming-schedule">
                            <div class="col-md-3 p-1">Scheduled on</div>
                            <div class="col-md-6 p-1 c-bl product-title">{{ upcoming_Schedule.schedule_date | formatDate }} {{ upcoming_Schedule.start_datetime | time}} - {{ upcoming_Schedule.end_datetime | time}}</div>
                            <div class="col-md-3">
                            <button :disabled="checkingdate(upcoming_Schedule.start_datetime, upcoming_Schedule.end_datetime) == 'no'" @click="connect(upcoming_Schedule.meeting_id, upcoming_Schedule._id)" v-if="upcoming_Schedule.status == 'Open'" type="button" class="b-radious btn connectbtn btn-sm pull-right">Connect</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5" v-if="upcoming_count == 0">
                    <div class="row upcoming upcomingData">
                        <div class="col-md-7">
                            <div class="box" style="min-height: 166px;">
                                <div class="box-header">
                                    <h5 class="box-title"></h5>
                                </div>
                                <div class="box-body" style="height: auto;">
                                    <ul class="products-list product-list-in-box mt-2">
                                    <li>
                                        <div class="d1">
                                            <a href="javascript:void(0)" class="product-title" style="color: #5AAE46!important;">
                                            <h4><b>We are happy to see you on screenit!</b></h4>
                                            </a>
                                            <span style="font-size: 12px;">
                                                <span class="text-muted">Make your hiring faster and unique with marketplace interviewers</span>
                                            </span>
                                        </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="box">
                                <div class="box-header">
                                    <!-- <span class="pull-right arrow-next"><i class="uil uil-arrow-right"></i></span>
                                    <span class="pull-right arrow-next mr-2"><i class="uil uil-arrow-left"></i></span> -->
                                </div>
                                <div class="box-body pull-right" style="height: auto;margin-top: 20px;">
                                    <img src="../assets/img/welcome-icon.svg" style="width: 84px;">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      <div class=" maincontent">
            <div class="row">
                <!-- <div class="col-md-12"> -->
                    <!-- <div class="" > -->
                        <div class="box-header searchArea">
                          <div class="headposition">
                            <h3 class="box-title fw-600">Recent Interviewer Description IDs</h3>
                            <div class="searchbar">
                              <div class="searchinput">
                                <input v-model="postsearch" type="text" class=" search-text" @keyup="getPostDatas"  placeholder="Search.." >
                                <button ><i class="fa fa-search"></i></button>
                              </div>
                            </div>
                            </div>
                        </div>
                        <!-- /.box-header -->
                        <div class="box-body">
                            <ul class="products-list product-list-in-box mypostlist">
                                <div v-if="dataslength < 1" class="text-muted tc" style="margin-top: 20%;">No data found</div>
                                <li v-else class="item itemClass" v-for="(x, index) in datas" :key="index">
                                    <div class="row">
                                        <div class="col-md-5 p-1" @click="showEditPostModal(x._id, x.post_id)">
                                            <div class="product-img round">
                                                <img @click="showEditPostModal(x._id, x)" v-if="x.profile_picture !='' && x.profile_picture !=null" :src="`${x.profile_picture}`">
                                                <img @click="showEditPostModal(x._id, x)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == null" src="../assets/img/default.png">
                                                <img @click="showEditPostModal(x._id, x)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Female'" src="../assets/img/female_default.png">
                                                <img @click="showEditPostModal(x._id, x)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Male'" src="../assets/img/male_default.png">
                                            </div>
                                            <div class="product-info d1">
                                                <a @click="showEditPostModal(x._id, x)" class="canName " :title="x.job_tittle">
                                                    <div class="validityclass">
                                                      <span :title="x.job_title" class="overflow1">{{x.job_tittle}}
                                                      </span>
                                                      <span class="">
                                                        <i v-if="x.post_expired =='true'" class="fa fa-circle" style="color:red; font-size:10px" aria-hidden="true"></i>
                                                        <i v-else class="fa fa-circle" style="color:#5bad2b; font-size:10px" aria-hidden="true"></i>
                                                        <!-- <img v-if="x.post_expired =='true'" src="../assets/img/expired.png" class="img-circle exp-imgmt-2">
                                                        <img v-else src="../assets/img/green_dot.svg" class="img-circle exp-imgmt-2"> -->
                                                      </span>
                                                    </div>
                                                    <!-- <span class="text-ago pull-right">{{ x.created_at | timeago }}</span> -->
                                                </a>
                                                <span class="product-description">
                                                    <span :title="x.post_unique_id" class="skill-lable">{{x.post_unique_id}}</span>
                                                </span>
                                            </div>
                                            <div class="col-md-11 p-1">
                                                <div class="ml-5 mt-2">
                                                    <span class="product-description" :title="x.primaryskillnames"><span class="skill-lable">Skills : </span>
                                                    {{x.primaryskillnames}}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-7 p-1">
                                            <div class="row">
                                                <div class="col-md-3 p-1"  style="text-align:center">
                                                    <a @click="viewCandidates('profile', x._id)">
                                                        <div class="countStyle">{{x.profile_count}}</div>
                                                        <div class="countSpecificationStyle">Profiles</div>
                                                    </a>
                                                </div>
                                                <div class="col-md-3 p-1"  style="text-align:center">
                                                    <a @click="viewCandidates('scheduled', x._id)">
                                                        <div class="countStyle">{{x.scheduled_count}}</div>
                                                        <div class="countSpecificationStyle">Scheduled</div>
                                                    </a>
                                                </div>
                                                <div class="col-md-3 p-1" style="text-align:center">
                                                    <a @click="viewCandidates('sit', x._id)">
                                                        <div class="countStyle">{{x.sit_count}}</div>
                                                        <div class="countSpecificationStyle">SIT>6</div>
                                                    </a>
                                                </div>
                                                <div class="col-md-3 p-1" style="text-align:center">
                                                    <a @click="viewCandidates('selected', x._id)">
                                                        <div class="countStyle">{{x.selected_count}}</div>
                                                        <div class="countSpecificationStyle">Selected</div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div class="row paginationClass" style="background-color: white;" v-if="dataslength > 0">
                              <jw-pagination :items="exampleItems" @changePage="onChangePage"></jw-pagination>
                            </div>
                        </div>
                    <!-- </div> -->
                <!-- </div> -->
            </div>
        </div>
        <EditPost v-if="editPostModalOpen" @editpost_emit="oncloseEdit" :postId="postId" :postData="postData" :shwovalueEditPost="editPostModalOpen"></EditPost>
    </section>
</template>
<script>
import axios from 'axios'
import * as Cookies from 'js-cookie'
import { BaseURL } from '../shared/classes'
import router from '../router/index'
// import ProfileModal from '../pages/Feature/profileDetails'
import Loading from 'vue-loading-overlay'
// import ReasonPopup from '../pages/Feature/reasonpopup'
import Vue from 'vue'
import moment from 'moment'
import 'vue-loading-overlay/dist/vue-loading.css'
import { Carousel, Slide } from 'vue-carousel'
import JwPagination from 'jw-vue-pagination'
import EditPost from '../newLayoutOrg/EditPostNew.vue'
Vue.component('jw-pagination', JwPagination)
Vue.use(moment)
// const exampleItems = [...Array(150).keys()].map(i => ({ id: (i + 1), name: 'Item ' + (i + 1) }))
export default {
  name: 'dashboard',
  data () {
    return {
      postsearch: '',
      postsort: 0,
      datas: [],
      tobedatas: [],
      getshedule: [],
      getresult: [],
      config: [],
      datassShow: 3,
      BaseURL: BaseURL,
      mainurl: '',
      modalOpen: false,
      editPostModalOpen: false,
      sheduleOpen: false,
      resultOpen: false,
      isLoading: true,
      fullPage: true,
      reasonopen: false,
      tobedataslength: 0,
      getshedulelength: 0,
      getresultlength: 0,
      total_post: 0,
      recent_post: 0,
      total_interest: 0,
      recent_interest: 0,
      total_schedule: 0,
      recent_schedule: 0,
      total_feedbacks: 0,
      recent_feedbacks: 0,
      upcoming_count: 0,
      recent_interest_data: [],
      recent_interest_data_lendth: 0,
      upcoming_Schedule: [],
      dataslength: 0,
      viewid: [],
      base_urls: BaseURL,
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      pageOfItems: [1],
      totalPages: 2,
      exampleItems: [],
      skip: 0,
      postId: null,
      postData: null
    }
  },
  components: {
    Loading, Carousel, Slide, EditPost
  },
  created () {
    this.config = {
      headers: {
        'content-type': 'application/json',
        Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
      }
    }
    this.getPostDatas()
  },
  mounted () {
    this.$root.$on('message_from_createdPost', (arg) => {
      this.getPostDatas()
    })
  },
  methods: {
    connect (id, sid) {
      Cookies.set('channel', id)
      Cookies.set('sid', sid)
      Cookies.set('type', 1)
      localStorage.setItem('type', 1)
      Cookies.set('baseMode', 'avc')
      Cookies.set('transcode', 'interop')
      Cookies.set('attendeeMode', 'video')
      Cookies.set('videoProfile', '480p_4')
      router.push('/agoraMod/meeting')
    },
    checkingdate (date, end) {
      var currentDate = new Date()
      var scheduledate = moment(date).subtract(5, 'minutes').toDate()
      scheduledate = moment(scheduledate).utc().format('YYYYMMDDHHmm')
      var endtime = moment.utc(end).format('YYYYMMDDHHmm')
      var currentdate = moment(String(currentDate)).format('YYYYMMDDHHmm')
      if (currentdate >= scheduledate && currentdate < endtime) {
        return 'yes'
      } else {
        return 'no'
      }
    },
    showModal (id, postid) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(postid))
      this.modalOpen = true
    },
    getPostDatas () {
      this.mainurl = '/dashboard/get_post_list/web'
      var formData = {
        skip: 0,
        search: this.postsearch,
        org_id: this.userInfo._id
      }
      axios.post(BaseURL + this.mainurl, {
        formData: formData
      }, this.config).then(response => {
        this.datas = response.data.post_list
        this.dataslength = this.datas.length
        this.isLoading = false
        this.exampleItems = [...Array(response.data.post_list_total_count).keys()].map(i => (i))
      }).catch(e => {
        console.log(e)
      })
    },
    navigation (tabs, id) {
      localStorage.setItem('postId', JSON.stringify(id))
      router.push({ name: tabs })
    },
    getDatas () {
      this.mainurl = '/dashboard/get_post_list/web'
      var formData = {
        skip: this.skip,
        search: this.postsearch,
        org_id: this.userInfo._id
      }
      axios.post(BaseURL + this.mainurl, {
        formData: formData
      }, this.config).then(response => {
        this.datas = response.data.post_list
        this.dataslength = this.datas.length
      }).catch(e => {
        console.log(e)
      })
    },
    onChangePage (pageOfItems) {
      this.skip = pageOfItems[0]
      this.getDatas()
    },
    showEditPostModal (id, postData) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      this.postId = id
      this.postData = postData
      // localStorage.setItem('postId', JSON.stringify(postId))
      // console.log('postId ', postId)
      // console.log('JSON.parse(localStorage.getItem ', JSON.parse(localStorage.getItem('postId')))
      this.editPostModalOpen = true
    },
    oncloseEdit (val) {
      this.editPostModalOpen = val.close
      if (val.reload === true) {
        this.skip = 0
        this.getDatas()
      }
    },
    viewCandidates (type = 'profile', id) {
      if (type === 'profile') {
        this.$router.push('/candidate_profiles/' + id + '/all')
      } else if (type === 'scheduled') {
        this.$router.push('/candidate_profiles/' + id + '/scheduled')
      } else if (type === 'sit') {
        this.$router.push('/candidate_profiles/' + id + '/sit6')
      } else if (type === 'selected') {
        this.$router.push('/candidate_profiles/' + id + '/selected')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
a {
    color: #333;
}
.product-list-in-box>.item:last-of-type {
  border-bottom-width: 1px;
}
.result {
  border: 1px solid #5bad2b !important;
  color: #5bad2b !important;
  margin-top: 6px;
}
.result-status-p {
  background-color: #F5F5F5;
  color: #60AB2F;
  padding: 3px 7px 4px 6px;
}
.result-status-c {
  background-color: red;
  color: #fff;
  padding: 3px 7px 4px 6px;
}
.post-empty {
  width: auto !important;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #5F2AF2;
  color: #5F2AF2;
  background-color: #fff;
  border-radius: 7px !important;
}
.vall {
  font-weight: 600;
}

.box-body {
  padding: 0px !important;
  height: 231px;
}
.box-title {
  font-size: 16px;
}
.card {
  background-color: white;
  border-radius: 9px;
}
.c-orange {
  color:orange;
}
.product-img img {
    border-radius: 50%;
}
.d1 {
    margin-bottom: 5px !important;
}
.fw-600 {
    font-weight: 600;
}
.fw-500 {
    font-weight: 500;
}
.bottom-count {
    background-color: #FAFAFA;
    padding: 7px 2px;
}
.products-list > .item {
    padding: 5px 10px !important;
}
/* .products-list .product-img img {
    width:60px !important;
    height: 60px !important;
} */
.product-list-in-box>.item:last-of-type {
    border-bottom-width: 1px;
}
.box-title {
  font-size: 16px;
}
.removeline:focus {
  outline: none !important;
}
.fa-2x {
  font-size: 2rem !important;
}
.countStyle {
    font-size: 2.5rem !important;
}
.countSpecificationStyle {
    font-size: 1.3rem !important;
}
.mypostlist {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    background-color: white;
    padding: 1% 2% 1% 2%;
    margin: 0%;
}
.itemClass {
    /* border: 0.5px solid rgb(185, 179, 179); */
    border-radius: 6px;
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
        background-color: #f5f5f5;

}
.mypostlist.itemClass:hover {
    background-color: white;
}
.headerClass {
    /* padding: 0px 40px 0px 40px; */
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
}
.upcomingData {
    margin-bottom: 10px;
}
.c-slide {
    background-color: #5AAE46;
    border-radius: 9px;
    height: 176px !important;
}
.c-slide-font {
  font-size: 16px;
}
.c-slide-title {
  font-size: 20px;
}
.maincontent{
  width: 100%;
  height: 100%;
  padding: 10px 4% 0% 4%;
}
.searchArea{
  background-color: white;
}
.headposition{
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.searchbar{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  column-gap: 5px;
  padding-right: 15px;
  background-color:white;
}
div.searchinput input[type=text] {
  padding: 10px;
  font-size: 14px;
  border: 1px solid lightgrey;
  float: left;
  width: 300px;
  outline: none;
}

div.searchinput button {
  float: left;
  width: 50px;
  padding: 10px;
  background: #5bad2b;
  color: white;
  font-size: 14px;
  border: 1px solid grey;
  border-left: none;
  cursor: pointer;
}

div.searchinput button:hover {
  background: green;
}

div.searchinput::after {
  content: "";
  clear: both;
  display: table;
}
.pagination {
  border-radius: 0px !important;
}
.active a.page-link {
  background-color: #5bad2b;
  border-color: #5bad2b;
}
.active a.page-link:hover {
  background-color: #5bad2b;
  border-color: #5bad2b;
}
.overflow1 {
    /* color: #999; */
  font-size: 16px;
  font-weight: 600;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 144px;
}
.paginationClass {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .headerClass {
    flex-direction: column;
    row-gap: 5px;
  }
  .c-slide {
    height: 120px !important;
  }
  .c-slide-font {
    font-size: 12px;
  }
  .c-slide-title {
    font-size: 14px;
  }
  .canName  {
    font-size: 18px;
    font-weight: bold;
  }
  .validityclass {
    display: flex;
    justify-content: row;
  }
}
</style>
